import { Button, Col, Divider, Form, Input, List, Row, Select, Switch, Typography } from "antd";
import { labelConfig } from "../../reports.config";
import { BOM } from "../../../../services/definedMethod";
import React from "react";
const { Text, Title } = Typography;
const { TextArea } = Input;
export default function ParameterScreen({ reportDetail }) {
  const parameterList = reportDetail?.reportParameters || [];
  console.log(reportDetail);

  return (
    <div>
      {parameterList?.length > 0 && (
        <List
          // itemLayout="horizontal"
          dataSource={parameterList}
          grid={{ gutter: 16, column: 2 }}
          renderItem={(item, index) => (
            <List.Item
              style={{
                display: "flex",
                margin: 0,
                border: "1px solid #d9d9d9",
                borderRadius: 10,
                padding: 20,
                marginBottom: 20,
              }}
              actions={[]}
            >
              {/* <Card> */}
              <List.Item.Meta title={item.parameterName} description={item.description} />
              <Button
                type="primary"
                danger
                disabled
                shape="round"
                size="small"
                // icon={<DeleteOutlined />}
                style={{
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  // marginLeft: "auto",
                }}
              >
                Remove
              </Button>
              {/* </Card> */}
            </List.Item>
            // <Card style={{ border: "1px solid red" }}></Card>
          )}
        />
      )}
    </div>
  );
}
